var $161394a6dbd1ea09$exports = {};
$161394a6dbd1ea09$exports = {
    "collapse": `\u{6536}\u{5408}`,
    "expand": `\u{5C55}\u{958B}`
};


export {$161394a6dbd1ea09$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
